export enum CriteriaOperatorEnum {
  AND = 'AND',
  OR = 'OR',
}
